import cn from 'classnames';
import { useRef } from 'react';

import styles from './tooltip.module.scss';
import { useTooltip } from './useTooltip';

export default function Tooltip({
  noResizeClosing,
  isSingleLineText,
  closeCallbackFC
} : {
  noResizeClosing?: boolean;
  isSingleLineText?: boolean;
  closeCallbackFC?: () => void;
}) {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const pointerRef = useRef<HTMLDivElement>(null);
  const { title, description, top, left, isOpen, closeTooltipHandler, pointerLeft, pointerTop } =
    useTooltip(tooltipRef, pointerRef, noResizeClosing, closeCallbackFC);

  return (
    <div
      className={cn(styles.wrapper, { [styles.isOpen]: isOpen })}
      onClick={closeTooltipHandler}
    >
      <div
        className={cn(styles.tooltip, { [styles.isOpen]: isOpen })}
        style={{ top: top, left: left }}
        ref={tooltipRef}
        data-test-id="tooltip"
      >
        <div className={styles.content}>
          <div className={styles.title} data-test-id="tooltip-title">
            {title}
          </div>
          <div className={cn(styles.description, {[styles.singleLine]: isSingleLineText})} data-test-id="tooltip-description">
            {description}
          </div>
        </div>
      </div>
      <div ref={pointerRef} className={styles.pointer} style={{ top: pointerTop, left: pointerLeft }} />
    </div>
  );
}
